import React from 'react'

const MatchesIcon = props => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.8794 11.069C17.8794 7.71423 15.1599 4.99469 11.8051 4.99469C8.45041 4.99469 5.73087 7.71423 5.73087 11.069C5.73087 14.4237 8.45041 17.1432 11.8051 17.1432H17.8794V11.069Z"
      fill="#374451"
    />
    <path
      d="M0.208862 7.01939C0.208862 3.66467 2.9284 0.945129 6.28313 0.945129C9.63785 0.945129 12.3574 3.66467 12.3574 7.01939C12.3574 10.3741 9.63785 13.0937 6.28313 13.0937H0.208862V7.01939Z"
      fill="currentColor"
    />
  </svg>
)

export default MatchesIcon
